// @ constants
import {
  MORTGAGE_BONUSES_PAYROLL,
  MORTGAGE_BONUSES_LIFE_INSURANCE,
  MORTGAGE_BONUSES_REPSOL,
  MORTGAGE_BONUSES_HOME_INSURANCE,
  MORTGAGE_BONUSES_WEALTH,
  MORTGAGE_BONUSES_CARDS
} from "constants/flagBasedFeatures";

const BONUSES_KEY = {
  homeInsurance: 'homeInsurance',
  payroll: 'payroll',
  lifeInsurance: 'lifeInsurance',
  energyAndGas: 'energyAndGas',
  wealth:'wealth',
  cards:'cards'
};

const ACTION_EVENTS = {
  [BONUSES_KEY.homeInsurance]: 'seguro de hogar open',
  [BONUSES_KEY.payroll]: 'nomina',
  [BONUSES_KEY.lifeInsurance]: 'seguro de vida open',
  [BONUSES_KEY.energyAndGas]: 'energia repsol: luz y gas',
  [BONUSES_KEY.wealth]: 'wealth: fondos de inversion y planes de pensiones',
  [BONUSES_KEY.cards]: 'tarjetas',

};

const FF_BONUSES = {
  [MORTGAGE_BONUSES_HOME_INSURANCE]: BONUSES_KEY.homeInsurance,
  [MORTGAGE_BONUSES_PAYROLL]: BONUSES_KEY.payroll,
  [MORTGAGE_BONUSES_LIFE_INSURANCE]: BONUSES_KEY.lifeInsurance,
  [MORTGAGE_BONUSES_REPSOL]: BONUSES_KEY.energyAndGas,
  [MORTGAGE_BONUSES_WEALTH]: BONUSES_KEY.wealth,
  [MORTGAGE_BONUSES_CARDS]: BONUSES_KEY.cards,

};

const BONUS_KEY_CSS = {
  [BONUSES_KEY.payroll]: 'payroll',
  [BONUSES_KEY.lifeInsurance]: 'life-insurance',
  [BONUSES_KEY.energyAndGas]: 'energy-and-gas',
  [BONUSES_KEY.wealth]:'wealth',
  [BONUSES_KEY.cards]:'cards'

}

const BONUSES_SUB_SUBTYPE={
  subTypeZeroArray:["payroll","homeInsurance","lifeInsurance","energyAndGas"],
  subTypeFiveArray:["payroll","homeInsurance"],
  subTypeSevenArray:["payroll","homeInsurance","lifeInsurance","energyAndGas","wealth","cards"],
  subTypeEightArray:["payroll","homeInsurance","lifeInsurance"]
}
        
const TAGGING_LABEL_EVENTS = {
  CANCEL_BUTTON: 'no me interesa',
  REPSOL_BUTTON: 'ir a contratar',
  HOME_INSURANCE: 'cotizar seguro',
  SHOW_MODAL: 'vista',
  CLOSE_MODAL_BUTTON: 'cerrar boton',
  CLOSE_MODAL_ICON: 'cerrar aspa',
  MORE_INFORMATION: 'mas informacion',
}

module.exports = {
  TAGGING_LABEL_EVENTS,
  BONUS_KEY_CSS,
  BONUSES_KEY,
  ACTION_EVENTS,
  FF_BONUSES,
  BONUSES_SUB_SUBTYPE
};